// extracted by mini-css-extract-plugin
export default {"item__wrapper":"styles_item__wrapper__WYVLu","img__container":"styles_img__container__HP9Hw"};